export default __webpack_public_path__ + "static/media/20w.07d5ecb4.svg";